export const CALLBACK_REASON_MESSAGES: Record<string, string> = {
  invalid_state: "OAuth state was invalid or expired. Please try again.",
  partner_not_found: "Could not match the partner from the callback.",
  exchange_failed: "Failed to exchange the authorization code with Igloohome.",
  missing_params: "OAuth response was missing required parameters.",
  duplicate_name: "An account with this name already exists."
};
